<template>
  <aside class="aside-menu">

  </aside>
</template>

<script>
export default {
  name: 'core-aside'
}
</script>



// WEBPACK FOOTER //
// src/components/core/Aside.vue